export const mockedSalesPerformanceMatYtd = {
  salesRecordsFound: true,
  currency: {
    currencyCode: 'EUR',
    currencyName: 'EUR',
  },
  marketPerformance: {
    revenue: {
      value: 95759261,
      percentage: 12.2,
    },
    growth: {
      value: 95759261,
      percentage: 14.2,
    },
    ytd: {
      value: 95759261,
      percentage: -11.9,
    },
    mat: {
      value: 95759261,
      percentage: 17.2,
    },
  },
  myPerformance: {
    revenue: {
      value: 95759261,
      percentage: 12.2,
    },
    growth: {
      value: 58756261,
      percentage: 9.9,
    },
    ytd: {
      value: 75454262,
      percentage: 16.3,
    },
    mat: {
      value: 92759239,
      percentage: -12.9,
    },
  },
  myRevenueShare: {
    selectedPeriod: {
      sharePercentage: 79.031,
      growthPercentage: 1.1,
    },
    ytd: {
      sharePercentage: 69.022,
      growthPercentage: 4.2,
    },
    mat: {
      sharePercentage: 59.909,
      growthPercentage: 7.3,
    },
  },
  myRevenueGrowthVsMarket: {
    selectedPeriod: {
      sharePercentage: 12.32,
      growthPercentage: 5.3,
    },
    ytd: {
      sharePercentage: 16.89,
      growthPercentage: 7.6,
    },
    mat: {
      sharePercentage: 56.78,
      growthPercentage: 2.2,
    },
  },
};

export const mockedSummarySalesPerformanceMatYtd = {
  valuePerformance: mockedSalesPerformanceMatYtd,
  volumePerformance: mockedSalesPerformanceMatYtd,
};

export const mockedOverviewSalePerformance = {
  salesRecordsFound: true,
  currency: {
    currencyCode: 'EUR',
    currencyName: 'EUR',
  },
  marketPerformance: {
    revenue: {
      value: 95759261,
      percentage: 12.2,
    },
    growth: {
      value: 95759261,
      percentage: 14.2,
    },
  },
  myPerformance: {
    revenue: {
      value: 95759261,
      percentage: 12.2,
    },
    growth: {
      value: 58756261,
      percentage: 9.9,
    },
  },
  myRevenueShare: {
    selectedPeriod: {
      sharePercentage: 79.031,
      growthPercentage: 1.1,
    },
  },
};

export const mockedSummaryOverviewSalesPerformance = {
  valuePerformance: mockedOverviewSalePerformance,
  volumePerformance: mockedOverviewSalePerformance,
};

export const mockedSalesPerformanceNoSalesRecords = {
  salesRecordsFound: false,
  currency: {
    currencyCode: '',
    currencyName: '',
  },
  marketPerformance: {
    revenue: {
      value: null,
      percentage: null,
    },
    growth: {
      value: null,
      percentage: null,
    },
    ytd: {
      value: null,
      percentage: null,
    },
    mat: {
      value: null,
      percentage: null,
    },
  },
  myPerformance: {
    revenue: {
      value: null,
      percentage: null,
    },
    growth: {
      value: null,
      percentage: null,
    },
    ytd: {
      value: null,
      percentage: null,
    },
    mat: {
      value: null,
      percentage: null,
    },
  },
  myRevenueShare: {
    selectedPeriod: {
      sharePercentage: null,
      growthPercentage: null,
    },
    ytd: {
      sharePercentage: null,
      growthPercentage: null,
    },
    mat: {
      sharePercentage: null,
      growthPercentage: null,
    },
  },
  myRevenueGrowthVsMarket: {
    selectedPeriod: {
      sharePercentage: null,
      growthPercentage: null,
    },
    ytd: {
      sharePercentage: null,
      growthPercentage: null,
    },
    mat: {
      sharePercentage: null,
      growthPercentage: null,
    },
  },
};

export const mockedSummarySalesPerformanceNoSalesRecords = {
  valuePerformance: mockedSalesPerformanceNoSalesRecords,
  volumePerformance: mockedSalesPerformanceNoSalesRecords,
};

export const PERFORMANCE_CARD_TITLE = 'Performance';
export const PERFORMANCE_TREND_TITLE = 'Performance Trend';
export const AVERAGE_SELLING_PRICE = 'Average Selling Price';
export const CATEGORY_CARD_TITLE = 'Category Leaderboard';
export const EXPLORE_LEADERBOARD_CARD_TITLE = 'Explore-Leaderboard';
export const EXPLORE_TRENDS_CARD_TITLE = 'Explore-Trends';
export const PRODUCT_TRENDS_CARD_TITLE = 'Product Trends';
export const EXPLORE_SEGMENTS_CARD_TITLE = 'Explore-Segments';
export const EXPLORE_CARD_TITLE = 'Explore';
export const EXPLORE_DOUBLE_BAR_CHART_TITLE = 'Explore Leaderboard Double Bar Chart';
export const EXPLORE_STACK_BAR_CHART_TITLE = 'Explore Segments Stack Bar Chart';
export const EXPLORE_LINE_CHART_TITLE = 'Explore Trends Line Chart';
export const EXPLORE_TRENDS_STACK_BAR_CHART = 'Explore Trends Stack Bar Chart';
export const CL_DOUBLE_BAR_CHART_TITLE = 'Category Leaderboard Double Bar Chart';
export const OPPORTUNITY_CARD_TITLE = 'Opportunity Review';
export const PERFORMANCE_ANALYSIS_CARD_TITLE = 'Performance by segments';
export const PERFORMANCE_ANALYSIS_TREND_CARD_TITLE = 'Performance by segments - Trend';
export const PERFORMANCE_ANALYSIS_MARKET_CARD_TITLE = 'Market';
export const PERFORMANCE_ANALYSIS_RETAILER_CARD_TITLE = 'Retailer';
export const PERFORMANCE_ANALYSIS_MARKET_TOOLTIP_MESSAGE =
  'Select a metric to see 13 period trended market performance / price information for the selected segment';
export const PERFORMANCE_ANALYSIS_TREND_RETAILER_TOOLTIP_MESSAGE =
  'Your benchmarked performance for the selected metric. For Revenue/Units, choose between Share (your share of each elements market sales) or Mix (each elements share of your overall sales in the category).';
export const PERFORMANCE_ANALYSIS_LINE_CHART_WARNING_PERIODICITY_MESSAGE =
  'Selected timeframe not applied to line chart - currently only standard period visualization possible.';
export const EXPLORE_TRENDS_LINE_CHART_WARNING_PERIODICITY_MESSAGE =
  'Aggregated periods not supported in this view, please select a single period';
export const OPPORTUNITY_REVIEW_BUBBLE_CHART_WARNING_PERIODICITY_MESSAGE =
  'Selected timeframe not applied to bubble chart - currently only standard period visualization possible.';
export const OPPORTUNITY_REVIEW_CARD_TITLE = 'Opportunity Review for Retailer';
export const RI_PRODUCT_LEADERBOARD_CARD_TITLE = 'Top Selling Products';
export const RI_PRODUCT_REVENUE_CONCENTRATION_TITLE = 'Revenue Concentration - top 5 products';
export const RI_PRODUCT_SELLING_PRODUCTS_TITLE = 'Selling Products';
export const RI_PRODUCT_SELLING_PRODUCTS_DESCRIPTION =
  'The number of distinct products in the current segment sold in the latest monthly or weekly period. New products have first activity in the latest monthly period.';
export const RI_INDICATIVE_TREND_ALERT_MESSAGE =
  'Suppressed tradebrand items aren’t included in these totals if filtering on suppressed feature values.';
export const RI_PRODUCT_TREND_TOP_5_PRODUCTS_CARD_TITLE = 'Top 5 products';
export const RI_PRODUCT_TREND_MARKET_CARD_TITLE = 'Market';
export const RI_PRODUCT_TREND_RETAILER_CARD_TITLE = 'Retailer';
export const RI_PRODUCT_OVERVIEW_VIEW_FULL_PRODUCT_TABLE = 'View full product table';
export const RI_PRODUCT_LEADERBOARD_SHOW_AND_RANK_BY = 'Show and rank by';
export const RI_PRODUCT_LEADERBOARD_TOP_SELLING_PRODUCTS_DOUBLE_BAR_CHART = 'Top Selling Products Double Bar Chart';
export const RI_PRODUCT_OVERVIEW_INDICATIVE_PERFORMANCE_TREND_CHART = 'Indicative Performance Trend';
export const RI_PRODUCT_LEADERBOARD_COMPARE_PRODUCTS_TITLE = 'Compare Models';
export const TRADING_ASSISTANT_RETAILER_MARKET_RELATIONSHIP_TITLE = 'Retailer and market relationship';
export const TRADING_ASSISTANT_RETAILER_WITHIN_BRAND_SUBTITLE = 'How important is the retailer to the brand?';
export const TRADING_ASSISTANT_BRAND_WITHIN_RETAILER_SUBTITLE = 'How important is the brand to the retailer?';
export const WARNING_CURRENCY_CONTAINER_MESSAGE =
  'Data for selected time frame is not currently available for the selected currency';
export const TRADING_ASSISTANT_RETAILER_WITHIN_BRAND_SUBTITLE_WITHIN =
  'How important is the retailer for the brand within ';
export const TRADING_ASSISTANT_BRAND_WITHIN_RETAILER_SUBTITLE_WITHIN =
  'How important is the brand for the retailer within ';
export const TRADING_ASSISTANT_CARD_TITLE = 'Trading Assistant';
